// Components==============
import React, { useContext } from 'react';
import './Reviewer.module.scss';
import Avatar from 'components/UI/Avatar/Avatar';
import { ReviewerAddModalContext } from '../ReviewerSelectModal';
// =========================

type Props = {
  reviewer?: UserEntity;
  type: 'first' | 'second' | 'no-select';
};

export default function Reviewer({ reviewer, type }: Props) {
  const {
    selectedFirstReviewer,
    setSelectedFirstReviewer,
    selectedSecondReviewer,
    setSelectedSecondReviewer,
    firstReviewerValue,
    secondReviewerValue,
    setFirstReviewerValue,
    setSecondReviewerValue,
  } = useContext(ReviewerAddModalContext);

  const boldString = (string: string, query?: string) => {
    if (!query) return string;

    const n = string.toUpperCase();
    const q = query.toUpperCase();
    const x = n.indexOf(q);
    if (!q || x === -1) {
      return string; // bail early
    }
    const l = q.length;
    return `${string.substr(0, x)}<strong>${string.substr(
      x,
      l
    )}</strong>${string.substr(x + l)}`;
  };

  const name = `${reviewer?.first_name} ${reviewer?.last_name}`;
  const boldName = boldString(
    name,
    type === 'first' ? firstReviewerValue : secondReviewerValue
  );

  // const displayMessage = message(user);
  const isFirstReviewer =
    selectedFirstReviewer &&
    reviewer &&
    selectedFirstReviewer.map((s) => s.id).includes(reviewer.id);

  const isSecondReviewer =
    selectedSecondReviewer &&
    reviewer &&
    selectedSecondReviewer.map((s) => s.id).includes(reviewer.id);

  const isTeacher =
    reviewer?.roles.map((r) => r.name).includes('Docent') ||
    reviewer?.roles.map((r) => r.name).includes('super-admin');

  const isExtern = reviewer?.roles.map((r) => r.name).includes('Extern');

  const handleFirstReviewer = () => {
    setSelectedFirstReviewer((prev: UserEntity[]) => {
      if (prev.length === 1 && prev[0].id === reviewer?.id) {
        // If reviewer is already selected and clicked again, remove it
        return [];
      }
      if (
        selectedSecondReviewer.length === 1 &&
        selectedSecondReviewer[0].id === reviewer?.id
      ) {
        // Remove first reviewer
        setSelectedSecondReviewer([]);
      }
      // If reviewer is not selected or a different reviewer is selected, replace the array with the new reviewer
      return reviewer ? [reviewer] : [];
    });
    setFirstReviewerValue('');
  };

  const handleSecondReviewer = () => {
    setSelectedSecondReviewer((prev: UserEntity[]) => {
      if (prev.length === 1 && prev[0].id === reviewer?.id) {
        // If reviewer is already selected and clicked again, remove it
        return [];
      }
      // If first reviewer is selected and clicked again
      if (
        selectedFirstReviewer.length === 1 &&
        selectedFirstReviewer[0].id === reviewer?.id
      ) {
        // Remove first reviewer
        setSelectedFirstReviewer([]);
      }
      // If reviewer is not selected or a different reviewer is selected, replace the array with the new reviewer
      return reviewer ? [reviewer] : [];
    });
    setSecondReviewerValue('');
  };

  return (
    <div
      // style={{
      //   pointerEvents: displayMessage ? 'none' : 'all',
      //   opacity: displayMessage ? 0.5 : 1,
      // }}
      onClick={() =>
        type === 'first'
          ? handleFirstReviewer()
          : type === 'second'
          ? handleSecondReviewer()
          : null
      }
    >
      <div
        styleName={`wrapper ${type === 'no-select' ? 'no-select' : ''}`}
        style={{
          backgroundColor: isFirstReviewer
            ? '#ececec'
            : isSecondReviewer
            ? '#ececec'
            : type === 'no-select'
            ? '#ececec'
            : 'initial',
        }}
      >
        {type === 'no-select' ? (
          <p styleName="no-select">Nog niemand geselecteerd</p>
        ) : (
          <>
            <Avatar user={reviewer} />
            <div
              dangerouslySetInnerHTML={{
                __html: `${boldName}`,
              }}
            />
            <div>
              <p>{isTeacher ? 'Docent' : isExtern ? 'Extern' : 'Student'}</p>
              {isFirstReviewer && <p styleName="reviewer">1e beoordelaar</p>}
              {isSecondReviewer && <p styleName="reviewer">2e beoordelaar</p>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
